import { render, staticRenderFns } from "./customStringKendoGridComponent.vue?vue&type=template&id=a2230988&"
import script from "./customStringKendoGridComponent.vue?vue&type=script&lang=js&"
export * from "./customStringKendoGridComponent.vue?vue&type=script&lang=js&"
import style0 from "./customStringKendoGridComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports